export default __webpack_public_path__ + "static/media/iplPart1.fa809176.jpg";